import { formatServerResponse } from '../utils';
import { SUPER_ADMIN_LICENSE_FETCH_SUCCESS } from '../types';

type LicenseState = unknown[];

interface LicenseAction {
  type: string;
  data?: unknown;
}

const initialState: LicenseState = [];

const LicenseReducer = (
  state: LicenseState = initialState,
  action: LicenseAction,
): LicenseState => {
  switch (action.type) {
    case SUPER_ADMIN_LICENSE_FETCH_SUCCESS:
      // action.data arrives untyped from the dispatched action, so narrow it to the
      // parameter type formatServerResponse expects at this boundary.
      return formatServerResponse(action.data as Parameters<typeof formatServerResponse>[0]);
    default:
      return state;
  }
};

export default LicenseReducer;
